Vue.component('product-modal', {
    data() {
        return {
            closed: false,
        }
    },
})